
import React, { useState } from "react";
// react library for routing
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { routes } from "routes";
import { premiumRoutes } from "routes";
import { getUserServiceLevel } from "api/authApiCall";
import { useNavigate } from 'react-router-dom'
import { getUserLogo } from "api/authApiCall";
import { useTranslation } from '../i18n/context';


function Admin() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();
  const [currentUserRouteState, setCurrentUserRouteState] = React.useState(null)
  const mainContentRef = React.useRef(null);
  const getServiceStatus = getUserServiceLevel();
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const navigate = useNavigate();
  const logoUrl = getUserLogo();
  const { t } = useTranslation();

  const getTranslatedRoutes = (routes) => {
    return routes.map(route => {
      // Check if the route has subcategories (nested routes in `views`)
      const translatedRoute = {
        ...route,
        name: route.name ? t(route.name) : route.name
      };

      if (route.views) {
        // If there are nested views, recursively translate them
        translatedRoute.views = getTranslatedRoutes(route.views);
      }

      return translatedRoute;
    });
  };

  React.useEffect(() => {

    // assuming you have service id
    const serviceId = getServiceStatus;
    // console.log(serviceId);

    if (serviceId === 2) {
      setCurrentUserRouteState(getTranslatedRoutes(premiumRoutes));
    }
    else if (serviceId == 1) {
      setShowErrorAlert(true);
      setTimeout(() => {
        navigate('/auth/login');
      }, 2000);
    } else {
      setCurrentUserRouteState(getTranslatedRoutes(premiumRoutes));
    }
  }, [getServiceStatus]);

  
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };
  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  // toggles collapse between mini sidenav and normal
  const toggleSidenav = (e) => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };
  const getNavbarTheme = () => {
    return location.pathname.indexOf("admin/alternative-dashboard") === -1
      ? "dark"
      : "light";
  };

  return (
    <>
      {
        currentUserRouteState && mainContentRef &&
        <>
          <Sidebar
            routes={currentUserRouteState}
            toggleSidenav={toggleSidenav}
            sidenavOpen={sidenavOpen}
            logo={{
              innerLink: "/admin/dashboard",
              imgSrc: logoUrl,
              imgAlt: "Company Logo",
            }}
          />
          <div className="main-content" ref={mainContentRef}>
            <AdminNavbar
              theme={getNavbarTheme()}
              toggleSidenav={toggleSidenav}
              sidenavOpen={sidenavOpen}
              brandText={getBrandText(location.pathname)}
            />
            <Routes>
              {getRoutes(currentUserRouteState)}
              <Route
                path="*"
                element={<Navigate to="/admin/dashboard" replace />}
              />
            </Routes>
            <AdminFooter />
          </div>
          {sidenavOpen ? (
            <div className="backdrop d-xl-none" onClick={toggleSidenav} />
          ) : null}
        </>
      }
    </>
  );
}

export default Admin;
